import { setTenantTimeZone, subscribeTenantTimeZone, tenantTimeZone } from '@kovix/shell-kit/format';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useSyncExternalStore } from 'react';
import { useSession } from '@/app/auth/session.store';
import { tenantKeys } from '@/entities/tenant/queries';
import { api } from '@/shared/lib/api';

import { pickTenantTimeZone } from './tenantTimeZonePick';

export { pickTenantTimeZone };

/**
 * T6-A (quyết định #5) + T9 A33 — đặt múi giờ tenant cho `format.date/dateTime` và `businessDate.tenantToday`. Gắn MỘT lần trong Shell (không hiển thị gì).
 * Hồ sơ tenant chỉ đọc khi quyền `/iam/me/permissions` chưa có `timeZone` VÀ phiên có `admin.tenant.overview` (cùng khóa cache + dạng dữ liệu với `useMyTenant`).
 */
export function TenantTimeZoneSync() {
  const mode = useSession((s) => s.mode);
  const tenantId = useSession((s) => s.tenantId);
  const permZone = useSession((s) => s.permissions?.timeZone ?? null);
  const canRead = useSession((s) => s.can('admin.tenant.overview'));
  const enabled = mode === 'tenant' && !!tenantId && canRead && !permZone;
  const { data } = useQuery({
    queryKey: tenantKeys.me(),
    queryFn: ({ signal }) => api.tenant.me(signal).then((r) => ({ ...r.data, etag: r.etag ?? `"${r.data.version}"` })),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
  const zone = pickTenantTimeZone(mode, permZone, enabled ? data?.timezone : undefined);
  useEffect(() => {
    setTenantTimeZone(zone);
  }, [zone]);
  return null;
}

/** Múi giờ tenant hiện hành — re-render khi `TenantTimeZoneSync` đổi múi giờ. */
export function useTenantTimeZone(): string {
  return useSyncExternalStore(subscribeTenantTimeZone, tenantTimeZone, tenantTimeZone);
}
